import { Component, HostListener, inject, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';

import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppResource } from './app.resource';
import { State } from './core/state/core.state';
import { Resource } from './resources/resource';
import { AppInsightsService } from './shared/services/app-insight.service';
import { WINDOW, WindowRef } from './shared/services/window.service';
import { GtmService } from './shared/services/google-tag-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Vyv-FrontSouscription';
  resource: Resource;
  private windowRef = inject<WindowRef>(WINDOW);
  constructor(
    private config: PrimeNGConfig,
    private appInsightService: AppInsightsService,
    private router: Router,
    private gtmService: GtmService,
    private store: Store<State>,
    protected resources: AppResource
  ) {
    this.resource = resources['resource'];
    this.preloadSVG();
  }

  async ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const url = event.url;
        if (url.includes('/start/')) {
          this.store.dispatch({ type: '[Init]' });
          sessionStorage.removeItem('state');
        }
      }
    });

    this.config.setTranslation({
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Decembre'
      ],
      monthNamesShort: [
        'Jan',
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Aou',
        'Sep',
        'Oct',
        'Nov',
        'Déc'
      ],
      dateFormat: 'dd/mm/yy',
      firstDayOfWeek: 1,
      today: "Aujourd'hui",
      weekHeader: 'Wk'
    });

    this.gtmService.init(environment.googleTagManagerId);
    this.trackPageViews();
  }

  private trackPageViews(): void {
    this.gtmService.pushEvent('page_view', {
      page_path: this.router.url,
      page_title: document.title
    });
  }

  loadScript(_url: string) {
    let node = document.createElement('script');
    node.src = _url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  @HostListener('document:appInsights_allowed', ['$event'])
  onAppInsightsAllowed(ev: any) {
    this.appInsightService.initAppInsights();
  }

  @HostListener('document:appInsights_disallowed', ['$event'])
  onAppInsightsDisallowed(ev: any) {
    this.appInsightService.disableAppInsights();
  }

  preloadSVG() {
    let svgs = [
      this.resource.header.logo,
      this.resource.header.step1,
      this.resource.header.step2,
      this.resource.header.step3,
      this.resource.houseapartment.apartmentPath,
      this.resource.houseapartment.apartmentWhitePath,
      this.resource.houseapartment.housePath,
      this.resource.houseapartment.houseWhitePath,
      this.resource.houseapartment.otherPath,
      this.resource.houseapartment.otherWhitePath,
      this.resource.primarysecondary.primaryPath,
      this.resource.primarysecondary.secondaryPath,
      this.resource.ownertenant.ownerPath,
      this.resource.ownertenant.ownerWhitePath,
      this.resource.ownertenant.tenantPath,
      this.resource.ownertenant.tenantWhitePath
    ];
    let frag = new Array<Node>();

    svgs.forEach(item => {
      let res = document.createElement('link');
      res.rel = 'preload';
      res.type = 'image/svg+xml';
      res.as = 'image';
      res.href = item;
      frag.push(res);
    });

    document.getElementsByTagName('head')[0].append(...frag);
  }
}
